const HEADER_KEYS = ['access-token', 'token-type', 'client', 'expiry', 'uid'];

export const getTokenHeadersFromLocalStorage = () => {
  const accessToken = localStorage.getItem('access-token');
  const tokenType = localStorage.getItem('token-type');
  const client = localStorage.getItem('client');
  const expiry = localStorage.getItem('expiry');
  const uid = localStorage.getItem('uid');

  return {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    uid,
    expiry,
  };
};

export const setTokenHeadersToLocalStorage = headers => {
  HEADER_KEYS.forEach(key => {
    localStorage.setItem(key, headers[key]);
  });
};

export const removeTokenHeadersFromLocalStorage = () => {
  HEADER_KEYS.forEach(key => {
    localStorage.removeItem(key);
  });
};



// WEBPACK FOOTER //
// ./src/hooks/useTokens.js